import React, { useContext, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import { VisitContext } from '../Context/contexts/VisitContext';
import { SHOW_TASKS, RESET_TASKS } from '../Context/constants';
import { SubmitTasksDiv } from '../../components/layout/TasksWrapper';

import defaults from '../../translations/en.json';

const useStyles = makeStyles(() => ({
  button: {
    lineHeight: 1,
    padding: '2px 8px',
    minHeight: 28,
    maxHeight: 28,
    height: 28,
    boxSizing: 'border-box',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
}));

export const SubmitTasks = () => {
  const [isSubmitDisabled, setSubmitDisabled] = useState<boolean>(false);
  const {
    dispatchVisit,
    savePatientAdminTask,
    deletePatientAdminTask,
    tasksToBeSaved,
    tasksToBeDeleted,
  } = useContext(VisitContext);
  const classes = useStyles();

  const onDiscardTasks = () => {
    dispatchVisit({
      type: SHOW_TASKS,
      payload: false,
    });
  };

  const onSubmitTasks = async () => {
    setSubmitDisabled(true);
    let savedOk = true;
    let deletedOk = true;

    if (tasksToBeSaved && Object.keys(tasksToBeSaved).length) {
      const taskAdded = Object.values(tasksToBeSaved);
      savedOk = await savePatientAdminTask(taskAdded);
    }
    if (tasksToBeDeleted && Object.keys(tasksToBeDeleted).length) {
      const taskDeleted = Object.keys(tasksToBeDeleted);
      const deleteResults = await Promise.all(
        taskDeleted.map((taskId) => deletePatientAdminTask(taskId)),
      );
      deletedOk = deleteResults.every(Boolean);
    }

    setSubmitDisabled(false);

    if (!savedOk || !deletedOk) {
      return;
    }

    dispatchVisit({
      type: RESET_TASKS,
    });
    setTimeout(() => {
      dispatchVisit({
        type: SHOW_TASKS,
        payload: false,
      });
    }, 1000);
  };

  return (
    <SubmitTasksDiv>
      <Button
        type="submit"
        variant="contained"
        size="small"
        disabled={isSubmitDisabled}
        onClick={onSubmitTasks}
        color="primary"
        classes={{
          root: classes.button,
        }}
      >
        {defaults.save}
      </Button>
      <Button
        type="submit"
        variant="contained"
        size="small"
        onClick={onDiscardTasks}
        color="primary"
        classes={{
          root: classes.button,
        }}
      >
        {defaults.doNotSave}
      </Button>
    </SubmitTasksDiv>
  );
};
